import {PollRobotTemplate} from './PollRobotTemplate.js';

export class PollResultsUpdate {
	constructor(parent, js) {
		[this.el, this.$] = PollRobotTemplate(`PollResultsUpdate`);
		parent.appendChild(this.el);
		this.clickTimer = window.setInterval( ()=>{ this.clockTick(); }, 1000);
		this.updateTimer = window.setInterval( ()=>{this.fetchUpdate(); }, 2500);
		this.startTime = new Date();
		this.$.title.innerText = js.Title;
		this.$.close.addEventListener(`click`, evt=>{
			evt.stopPropagation(); evt.preventDefault();
			this.el.dispatchEvent(new CustomEvent(`pollrobot-close-poll`,
				{ 
					bubbles: true,
					composed: true,
					detail: {
						poll_id: this.js.ID,
						ask_id: this.js.AskID,
					}
				}
				));
		});
		this.js = js;
		this.askId = js.AskID;
	}
	fetchUpdate() {
		let u = `/poll/result/${this.js.ID}/latest`;
		fetch(u)
		.then(r => r.json())
		.then(js => {
			console.log(js);
			this.$.count.innerText = js.answer_count;
		})
		.catch(err=>{
			console.log(`error on ${u}: `, err);
			alert(err);
		});
	}
	zpad(s) {
		return s.toString().padStart(2,`0`);
	}
	clockTick() {
		let now = new Date();
		let ts = Math.floor( (now.getTime() - this.startTime.getTime())/1000 );
		let h = Math.floor(ts / 3600);
		let m = Math.floor(ts / 60) % 60;
		let s = ts % 60;
		this.$.clock.innerText = `showing ${this.zpad(h)}:${this.zpad(m)}:${this.zpad(s)}`;
	}
	close() {
		window.clearInterval(this.clickTimer);
		window.clearInterval(this.updateTimer);
		this.el.remove();
	}
}